var exports = {
  "list": "list-R19mO",
  "entry": "entry-R19mO",
  "miniTitleInfo": "miniTitleInfo-R19mO",
  "title": "title-R19mO",
  "metaRow": "metaRow-R19mO",
  "subtitle": "subtitle-R19mO",
  "author": "author-R19mO",
  "published": "published-R19mO",
  "origin": "origin-R19mO",
  "fullTextInfo": "fullTextInfo-R19mO",
  "thumbs": "thumbs-R19mO",
  "thumbStripe": "thumbStripe-R19mO",
  "zoomed": "zoomed-R19mO",
  "miniTitleWrap": "miniTitleWrap-R19mO",
  "miniTitleSegment": "miniTitleSegment-R19mO",
};

__webpack_require__.r(module.exports = exports);
